<div
  #originRef
  (click)="showPopover(originRef)"
  [class.bg-hover]="dropdownOpen"
  class="flex items-center cursor-pointer relative trans-ease-out select-none rounded-full hover:bg-hover"
  matRipple
>
  <div
    class="rounded-full h-9 w-9 flex items-center justify-center text-primary bg-primary/10"
  >
    <mat-icon svgIcon="mat:person"></mat-icon>
  </div>
</div>
